export default __webpack_public_path__ + "static/media/icon_ui_radiobutton_on.9b86c858.png";